<template>
  <div></div>
</template>

<script>
	import util from "@/libs/util.js";
	
	export default {
		mounted() {
			// 退出登录
			util.cookies.remove('token');
			window.location.href = "/";
		},
	}
</script>
